import * as process from 'process';

import {getDefaultConfig, makeResponseSafe} from '@utils/omicron';

import type {OmicronConfigType, OmicronResponse} from './schemas';
import {OmicronConfigSchema} from './schemas';

export const omicronFallback: OmicronResponse = {
  config: getDefaultConfig<OmicronConfigType>(OmicronConfigSchema),
};

export const fetchOmicron = async (
  omicronUrl?: string,
  omicronConfigId?: string,
  omicronEnv?: string,
  withCookie?: boolean,
): Promise<OmicronResponse> => {
  try {
    const omicronPath =
      typeof window !== 'undefined'
        ? process.env.CLIENT_OMICRON_URL
        : process.env.SERVER_OMICRON_URL;

    const url = omicronPath ?? omicronUrl;
    const configId = process.env.OMICRON_URL_CONFIG_ID ?? omicronConfigId;
    const env = process.env.OMICRON_URL_ENV ?? omicronEnv;

    const params = new URLSearchParams({
      config_id: configId as string,
      env: env as string,
    });

    const response = await fetch(`${url}/omicron/config?${params.toString()}`, {
      credentials: withCookie ? 'include' : 'same-origin',
      cache: 'no-cache',
    });

    if (!response.ok) {
      return omicronFallback;
    }

    const jsonData = await response.json();

    return makeResponseSafe<OmicronConfigType>(OmicronConfigSchema, jsonData);
  } catch (e) {
    return omicronFallback;
  }
};
